import { Component, Inject, OnInit } from '@angular/core';
import { SendRecoveryPasswordDialogComponent } from '../send-recovery-password-dialog/send-recovery-password-dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-send-dialog',
  templateUrl: './email-send-dialog.component.html',
  styleUrls: ['./email-send-dialog.component.css']
})
export class EmailSendDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SendRecoveryPasswordDialogComponent>, @Inject(MAT_DIALOG_DATA) public obj: any) { }

  ngOnInit(): void {
  }

  closeDialog(){
    this.dialogRef.close();
  }

}
